import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { TemplatePreviewDialogComponent } from 'src/app/components/template-preview-dialog/template-preview-dialog.component';
import { AttendeeService } from 'src/app/service/attendee.service';
import { DashboardService } from 'src/app/service/dashboard.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ProjectStatusDialogComponent } from 'src/app/components/right-side-opener/project-status-dialog.component';
import { PermissionService } from 'src/app/service/permission.service';


@Component({
  selector: 'app-create-meeting-template-view',
  templateUrl: './create-meeting-template-view.component.html',
  styleUrls: ['./create-meeting-template-view.component.css']
})
export class CreateMeetingTemplateViewComponent implements OnInit {

  listOfOptions: any;
  isLoading : boolean = false;
  meetingData: any;
  templateNames:any;
  existMeetingId:any;
  categoryType: any = <any>[];
  searchText:any;
  private readonly notifier!: NotifierService;
  meetingObj: any = {};
  meetingTypeFetcher!: string;
  calledFrom:any;
  meetingInfoData: any;
  selectedItem:any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
  )
  
  constructor(private permissionService:PermissionService, private spinner: NgxSpinnerService,private readonly breakpointObserver: BreakpointObserver,private activatedroute: ActivatedRoute,private dashBoardService:DashboardService,private sideNav : SideNavServiceService,public router : Router,private utilityService: UtilityService, private globals: Globals,private meetingService: MeetingService,private attendeeService:AttendeeService,public dialog: MatDialog, notifierService: NotifierService, private route: ActivatedRoute) {
    
    this.notifier = notifierService;
    this.activatedroute.queryParams.subscribe(
      params => {
        this.existMeetingId = params['meetingId'];
        this.calledFrom = params['calledFrom'];
      });
 
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId")};
    this.meetingService.loadCategory(categoryReq).subscribe(response => {
   
        this.categoryType = response.body;
   
    });
    
  }

  ngOnInit(): void {
    this.selectedItem = 0;
    this.isLoading=true;
    this.route.queryParams.subscribe(params => {
 
      this.meetingTypeFetcher = params.meetingType
      this.existMeetingId = params.meetingId
      this.calledFrom = params.calledFrom;
 
    });
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"fkCategory":0};
    this.meetingService.getTemplateNameByCategory(categoryReq).subscribe((templateName:any)=>{
 
      this.templateNames=templateName.body;
      
        this.isLoading = false;
    });
  }

  navigateBack(){
  
 
    if(this.existMeetingId && this.meetingTypeFetcher == 'S'){      
   
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });
    }
    else if(this.existMeetingId && this.meetingTypeFetcher == 'I'){
      this.sideNav.openInstantMeeting(true);
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });
    }
    else{
      
      this.router.navigate(['/dashboard'])
    }
  }

    previewTemplate(templateId:any,templateName:any){
 
      this.spinner.show();
      
      this.meetingService.getTemplateByTemplateId(templateId).subscribe((resp:any)=>{
        //var template = resp.body;
   
        this.meetingService.fetchMeetingInfo(resp.body.fkMeetingId).subscribe(
          (meetingRes: any) => {
            this.spinner.hide()
            this.meetingInfoData = meetingRes.body
       
            const d = this.dialog.open(ProjectStatusDialogComponent,{
              data : {meetingData : this.meetingInfoData, existMeetingId:this.existMeetingId, selTemplate:templateName, templateId:templateId,hide : true, hideUseTemplate : false},
              panelClass: ['animate__animated','animate__slideInRight', 'responsive-class'],
              disableClose: false,
              position : {
                left : "50%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width : "50%",
              height : "100vh"
            })
            const mediumDialogSubscription = this.isMedium.subscribe(size => {
              if(size.matches){
                d.updateSize('70vw','100vh');
              }
            })
            const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
              if (size.matches) {
                d.updateSize('100vw', '100vh');
              } else {
                d.updateSize('calc(100% - 50px)', '100vh');
              }
            });
            const smallSubscription = this.isSmall.subscribe(size => {
              if(size.matches){
                d.updateSize('100vw', '100vh');
              }
            })
            d.afterClosed().subscribe(() => {
              smallDialogSubscription.unsubscribe();
              smallSubscription.unsubscribe();
              mediumDialogSubscription.unsubscribe();
            });
          });
       
         });
    }
  updateSelection(categoryId: any) {
    this.selectedItem = categoryId;
    this.searchText='';
      this.isLoading=true;
 
      var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"fkCategory":categoryId};
      this.meetingService.getTemplateNameByCategory(categoryReq).subscribe((templateName:any)=>{
   
        this.templateNames=templateName.body;
          this.isLoading = false;
      });
      //this.selectedTemplate = template
    }

  selectedCategory(e : any){
 
  }

  searchTemplateText(event : any){
    this.searchText = event.target.value
  }
  searchTemplateName(data:any){
    this.isLoading=true;
 
    var reqJSON={
      "templateName":data,
      "orgCode":localStorage.getItem("orgCode"),
      "userId":localStorage.getItem("userId")
    };
    this.meetingService.getTemplatesByName(reqJSON).subscribe((templateName:any)=>{
 
      this.templateNames=templateName.body;
        this.isLoading = false;
    });
  }
//   meetingDetails(templateId:any, template:any) {
//     var reqJSON={"templateName":template,"meetingId":this.existMeetingId, "orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"templateId":templateId};

//     this.spinner.show();
//     if(this.existMeetingId!=undefined || this.existMeetingId!=null){
//       this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
//         
//         this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });  
//         this.dialog.closeAll();
//       }).add(()=>{
//         this.spinner.hide();
//         //this.notifier.notify("success","Template loaded successfully");
//       });
//     }else{
//       this.meetingObj = {};
//       this.meetingObj = {
//         "meetingDateStr": this.utilityService.nvl(this.utilityService.getDefaultMeetingDate()),
//         "meetingStartTime": this.utilityService.nvl(this.utilityService.getDefaultMeetingTime()),
//         "orgCode": this.globals.orgCode,
//         "userId": this.globals.userId,
//         "visitorTimeZone": this.globals.vTimeZone,
//         "duration": environment.defMeetingDuration,
//         "logType":this.globals.logType,
//         "meetingTitle":template
//       }
//       this.meetingService.createNewMeeting(this.meetingObj).subscribe(data => {
//         
//         if (data != null && data != undefined && data.body != null && data.body != undefined) {
//           if (data.body.meetingId != null) {
//             ////consolee.log("meeting>>" + JSON.stringify(data.body));
//             reqJSON={"templateName":template,"meetingId":data.body.meetingId, "orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"templateId":templateId};
//             this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
//               
//               this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : data.body.meetingId }) }, skipLocationChange: true, replaceUrl: false });  
              
//             });
//           }
//         }
//       }).add(() => {
//         this.spinner.hide();
//           //Called when operation is complete (both success and error)
//       });
//     }
// }

  
  loadMeetingFromTemplate(template:any){
    
    /*in case of use template*/
    this.spinner.show();
    if(template!=null && template!=undefined && this.existMeetingId!=undefined && this.existMeetingId!=null && this.calledFrom!=undefined && this.calledFrom=="MUT"){
      var reqJSON={"templateName":template.templateName,"meetingId":this.existMeetingId, "orgCode":localStorage.getItem("orgCode"),"userId":this.globals.userId,"templateId":template.templateId,"isCopyMinutes":'N',"includeAgenda":'Y',"includeAttendee":'Y'};
        this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
          
          this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });  
          if(this.dialog!=undefined){
            this.dialog.closeAll();
          }
        }).add(()=>{
          this.spinner.hide();
        });
      }else{
      /*in case blank template or other template*/
      this.meetingObj = {};
        this.meetingObj = {
          "meetingDateStr": this.utilityService.nvl(this.utilityService.getDefaultMeetingDate()),
          "meetingStartTime": this.utilityService.nvl(this.utilityService.getDefaultMeetingTime()),
          "orgCode": this.globals.orgCode,
          "userId": this.globals.userId,
          "visitorTimeZone": this.globals.vTimeZone,
          "duration": environment.defMeetingDuration,
          "logType":this.globals.logType
       }
        if(template!=undefined && template!=null && this.utilityService.nvl(template.templateName)!=""){
          this.meetingObj.meetingTitle = this.utilityService.nvl(template.templateName);
        }else{
          this.meetingObj.meetingTitle = environment.defMeetingTitle;
        }
        if(template!=undefined && template.fkMeetingId!=undefined){
          this.meetingObj.templateMeetingId=template.fkMeetingId;
        }

        this.spinner.show();
        this.meetingService.createNewMeeting(this.meetingObj).subscribe(data => {
          
          if (data != null && data != undefined && data.body != null && data.body != undefined) {
            if(template!=null && template!=undefined && data.body.meetingId != null) {
              this.existMeetingId=data.body.meetingId;
              this.calledFrom="MUT";/*for use template option*/
              this.loadMeetingFromTemplate(template);
            }else{
              /*for default creation*/
              this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(data.body) }, skipLocationChange: true, replaceUrl: false });
            }
          }
        },
          err => {
            //
          }).add(() => {
            this.spinner.hide();
          });
        }
  
  }

  
}
